export const STORE_NAME = 'jira.insights.container-store';
